import Swal from "sweetalert2";
import EmailService from "../../../../../Services/Api/EmailService";

export default {
    methods: {
        removeLanguage(e) {
            const index = this.tabs.findIndex(item => item.value === e)
            Swal.fire({
                title: this.$t('pages.template_builder.remove_alert.title'),
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: this.$t('pages.template_builder.remove_alert.yes')
            }).then(result => {
                if (result.value) {
                    this.tabs.splice(index, 1)
                    Swal.fire(this.$t('pages.template_builder.remove_alert.deleted'),'', "success");
                }
            });
        },
        sendTestEmail() {
            Swal.fire({
                input: "email",
                inputValue: "barisozer.16@gmail.com",
                title: this.$t('email_builder.modal.send.title'),
                icon: "info",
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: this.$t('email_builder.modal.send.yes'),
                validationMessage: this.$t('email_builder.modal.send.wrong'),
            }).then(async (result) => {
                if (result.value) {
                    const template = this.tabs.find(x => x.value === this.currentLang)

                    const formData = new FormData()
                    formData.append('templateName', this.templateName)
                    formData.append('content', template.content)
                    formData.append('subject', template.subject)
                    formData.append('value', template.value)
                    formData.append('email', result.value)

                    if (this.logo) {
                        formData.append('logo', this.logo)
                    }
                    if (this.attachment) {
                        formData.append('attachment', this.attachment)
                    }

                    await EmailService.sendTestEmail({payload: formData}).then(() => {
                        Swal.fire(this.$t('email_builder.modal.send.sent'), this.$t('email_builder.modal.send.text'), "success");
                    }).catch(() => {
                        Swal.fire(this.$t('email_builder.modal.send.notSent'), this.$t('email_builder.modal.send.error'), "error");
                    })
                }
            });
        },
    }
}